import { lazy } from 'react';

export const RewardCreateForm = lazy(() => import('./RewardCreateForm'));
